import React from "react"
import { AppButtonIcon } from "@components"
import { isOpenInfoModal } from "Pages/ReportsAlerts/Reports/@signals"


export default function ReportTableInfoModalAction({ idReport }) {

	return <AppButtonIcon
		data-tour-id="tour-show-report-info"
		icon="circle-info"
		tooltip="Show Report Info"
		onClick={() => isOpenInfoModal.value = idReport}
	/>
}